import { render, staticRenderFns } from "./YinHuaShuiResult.vue?vue&type=template&id=97f3789e&scoped=true&"
import script from "./YinHuaShuiResult.vue?vue&type=script&lang=js&"
export * from "./YinHuaShuiResult.vue?vue&type=script&lang=js&"
import style0 from "./YinHuaShuiResult.vue?vue&type=style&index=0&id=97f3789e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f3789e",
  null
  
)

export default component.exports